<template>
  <div class="my-10">
    <h2 class="font-bold text-2xl">{{ $t('page.selectBusinessAccount') }}</h2>
    <div
      class="mt-10 grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1"
    >
      <template v-for="item in accounts" :key="item.id">
        <!-- ✅ активная BA: обычный переход как раньше -->
        <router-link
          v-if="canEnterBusinessAccount(item)"
          :to="{ name: 'selectCategory', query: { business_account: item.id } }"
        >
          <MyBusinessAccountCard :detail="item" />
        </router-link>

        <!-- ✅ просроченная BA: перехода нет, только toast -->
        <div
          v-else-if="isExpiredBusinessAccount(item)"
          class="relative cursor-pointer"
          @click="showExpiredNotification"
        >
          <MyBusinessAccountCard :detail="item" />
          <div class="absolute top-0 left-0 rounded-lg h-full w-full bg-[#303030] opacity-20"></div>
        </div>

        <!-- ✅ остальные заблокированные статусы: как и было, без перехода -->
        <div v-else class="relative">
          <MyBusinessAccountCard :detail="item" />
          <div class="absolute top-0 left-0 rounded-lg h-full w-full bg-[#303030] opacity-20"></div>
        </div>
      </template>

      <div v-show="accounts.length === 0 && loading === false">
        <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
      </div>
    </div>

    <div v-show="loading === true" class="flex justify-center mt-10" role="status">
      <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color" />
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import MyBusinessAccountsNav from '@cmp/businessProfile/MyBusinessAccountsNav.vue';
import BusinessAccountCard from '@cmp/media/BusinessAccountCard.vue';
import MyBusinessAccountCard from '@cmp/MyBusinessAccountCard.vue';

export default {
  name: 'MyBusinessAccounts',
  components: {
    MyBusinessAccountsNav,
    BusinessAccountCard,
    MyBusinessAccountCard,
  },
  data() {
    return {
      loading: false,
      accounts: [],
    };
  },
  methods: {
    isExpiredBusinessAccount(item) {
      return Number(item?.status) === 2;
    },

    canEnterBusinessAccount(item) {
      const status = Number(item?.status);
      return status !== 2 && status !== 3;
    },

    showExpiredNotification() {
      this.$toast.info(this.$t('warning.BA_RENEW_REQUIRED'));
    },

    async getAccounts() {
      this.loading = true;
      try {
        const response = await api.get('posts/my-business-accounts/');
        this.accounts = response.data.results || [];

        // ✅ fallback: нет BA → обычное добавление (выбор категории)
        if (this.accounts.length === 0) {
          this.$router.replace({ name: 'selectCategory' });
          return;
        }

        // ✅ если BA один → сразу дальше, но только если он не просрочен и не заблокирован
        if (
          this.accounts.length === 1 &&
          this.accounts[0]?.id &&
          this.canEnterBusinessAccount(this.accounts[0])
        ) {
          this.$router.replace({
            name: 'selectCategory',
            query: { business_account: this.accounts[0].id },
          });
          return;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>
